/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import OzModalButton from './partials/OzModalButton';
import Wrapper from './Wrapper';
import ClaimForm from './partials/ClaimForm';
import './Claim.css';
import {
  fetchUser,
  getCompany,
  setAccount,
} from '../actions';


class Claim extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['company', getCompany, p => p.id],
  ]

  state = {};

  renderListing() {
    let company = this.props.company;
    if (!company) return;

    let locations = company.locations || [];

    let nodes = locations.map(location => {
      let rooms = location.rooms;
      rooms.sort((a, b) => a.name.localeCompare(b.name));
      let roomNodes = location.rooms.map(room => {
        return (
          <li key={room.id}>{room.name}</li>
        );
      });
      return (
        <div key={location.id} className="location">
          <div className="location-name">{location.address}</div>
          <div className="location-rooms"><ul>{roomNodes}</ul></div>
        </div>
      );
    });

    return (
      <div className="listing">
        <div className="company-name">{company.name}</div>
        <div className="locations">{nodes}</div>
      </div>
    )
  }

  claim(e, values) {
    this.props.setAccount(values)
      .then(resp => {
        console.log('set acount resp', resp);
        if (resp.error) return;
        this.props.fetchUser()
          .then((resp) => {
            console.log('fetch user resp', resp);
            navTo('/pro/rooms');
          });
      });
  }

  renderClaimForm() {
    let user = this.props.user;
    if (!user) return;

    let email = null;
    if (user.email && user.email.indexOf('dummy') == -1) {
      email = user.email;
    }

    return (
      <div className="claim">
        <OzModalButton
          modalTitle={'Claim Listing'}
          show={this.state.claiming}
          onShow={() => this.setState({ claiming: true })}
          onHide={() => this.setState({ claiming: false })}
          >

          <Button bsSize="lg">Claim Listing</Button>

          <ClaimForm
            modal={true}
            values={{ username: user.username, email: email }}
            errors={this.props.errors.claim}
            onCancel={() => this.setState({ claiming: false })}
            onSubmit={(e, values) => this.claim(e, values)}
            buttonText="Claim Listing"
            cancelText="Cancel"
            company={this.props.company}
          />
        </OzModalButton>
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="Claim" title="Claim Your Listing">
        {this.renderListing()}
        {this.renderClaimForm()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    company: state.get.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    setAccount,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Claim);



/** WEBPACK FOOTER **
 ** ./src/components/Claim.js
 **/